import {AppApi} from 'store/customer/api';
import {mapHiddenMaterials} from 'components/customer/Product/helpers/mapHiddenMaterials';
import {mapShelfThickness} from 'components/customer/Product/helpers/mapShelfThickness';
import {Cabinet} from 'components/customer/Product/entity/Cabinet';
import {Product} from 'components/customer/Product/entity/Product';
import {ProductApi} from 'components/customer/Product/entity/ProductApi';
import {Structure} from 'components/customer/Product/entity/Structure';
import {Validation} from 'components/customer/Product/entity/Validation';
import {ProductForm} from 'components/customer/Product/entity/ProductForm';
import {HardwareOption} from 'shared/types/HardwareOption';
import {JobCabinet, JobRoom} from 'components/customer/Job/store/jobApi';
import {RoomResponse} from 'components/customer/Product/entity/Room';
import {RoomPlannerLayout} from 'components/customer/RoomPlanner/types';
import {mapJobCabinetsToProducts} from 'components/customer/Product/helpers/mapJobCabinetsToProducts';

type PreviewPayloadProps = {
    cabinet: Cabinet;
    job_cabinet: Product;
    majorDimensions?: string[][];
    structure: Structure[];
    success: number;
    validation?: Validation[];
    hardware_options: HardwareOption[];
    product_info: JobCabinet;
};

type PreviewResultProps = {
    product_config: ProductForm;
    cabinet: Cabinet;
    job_cabinet: Product;
    hardware_options: HardwareOption[];
    product_info: JobCabinet;
};

type RoomPreviewPayload = {
    room: RoomResponse;
    layout: RoomPlannerLayout;
    product_info: JobRoom;
    hardware_options: HardwareOption[];
    job_cabinets: ProductApi[];
    success: number;
};

export type RoomPreviewResponse = {
    room: RoomResponse;
    layout: RoomPlannerLayout;
    product_info: JobRoom;
    hardware_options: HardwareOption[];
    job_cabinets: Product[];
    success: number;
};

// The following contains the endpoints for 3d preview
const PreviewApi = AppApi.injectEndpoints({
    endpoints: (builder) => ({
        getCabinetPreview: builder.query<PreviewResultProps, {slug: string}>({
            query: ({slug}) => `/jobcabinet/${slug}/preview`,
            transformResponse: (response: PreviewPayloadProps) => ({
                cabinet: response.cabinet,
                job_cabinet: {
                    ...mapHiddenMaterials(response.job_cabinet),
                    shelves: mapShelfThickness(response.job_cabinet.shelves),
                },
                product_config: {
                    majorDimensions: response.majorDimensions,
                    validation: response.validation,
                    structure: response.structure,
                },
                hardware_options: response.hardware_options,
                product_info: response.product_info,
            }),
        }),

        getRoomPreview: builder.query<RoomPreviewResponse, {slug: string}>({
            query: ({slug}) => `/room/${slug}/preview`,
            transformResponse: (
                response: RoomPreviewPayload
            ): RoomPreviewResponse => ({
                ...response,
                job_cabinets: mapJobCabinetsToProducts(
                    response.job_cabinets ?? []
                ),
            }),
        }),
    }),
});

export const {useGetCabinetPreviewQuery, useGetRoomPreviewQuery} = PreviewApi;
